<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.homeNotice.form.title')" prop="title" >
        <a-input v-model="form.title" :placeholder="$t('views.homeNotice.form.titlePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.homeNotice.form.content')" prop="content" >
        <editor :key="'homeNotice-content-' + (form.id || 'new')" v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.homeNotice.form.contentEn')" prop="contentEn" >
        <editor :key="'homeNotice-contentEn-' + (form.id || 'new')" v-model="form.contentEn" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.homeNotice.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.homeNotice.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHomeNotice, addHomeNotice, updateHomeNotice } from '@/api/user/homeNotice'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formType: 1,
      open: false,
      form: {
        id: null,
        title: null,
        content: null,
        contentEn: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1
        ? this.$t('views.homeNotice.title.add')
        : this.$t('views.homeNotice.title.edit')
    },
    rules () {
      return {
        title: [
          { required: true, message: this.$t('views.homeNotice.rule.titleRequired'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('views.homeNotice.rule.contentRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        content: null,
        contentEn: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHomeNotice({ id }).then(response => {
        const d = response.data || {}
        const merged = { ...this.form, ...d }
        if (merged.content == null) merged.content = ''
        if (merged.contentEn == null) merged.contentEn = ''
        this.form = merged
        this.open = true
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHomeNotice(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.homeNotice.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.homeNotice.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHomeNotice(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.homeNotice.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.homeNotice.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
